import { render, staticRenderFns } from "./taskSwitchView.vue?vue&type=template&id=0ddf3dff&"
import script from "./taskSwitchView.vue?vue&type=script&lang=js&"
export * from "./taskSwitchView.vue?vue&type=script&lang=js&"
import style0 from "./taskSwitchView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports